/**
 * Generated by kubb.
 * Do not edit manually.
 * Shape Global API
 */

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../global-client';
import type { RequestConfig, ResponseErrorConfig } from '../../global-client';
import type {
  DeleteApiChannelsDevicesDeviceIdMutationResponseSchema,
  DeleteApiChannelsDevicesDeviceIdPathParamsSchema,
  DeleteApiChannelsDevicesDeviceId401Schema,
} from '../types/deleteApiChannelsDevicesDeviceIdSchema';
import type {
  DeleteApiLogoutMutationResponseSchema,
  DeleteApiLogout401Schema,
  DeleteApiLogout422Schema,
} from '../types/deleteApiLogoutSchema';
import type {
  DeleteApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
  DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema,
  DeleteApiPushSubscriptionsPushSubscriptionId401Schema,
  DeleteApiPushSubscriptionsPushSubscriptionId404Schema,
} from '../types/deleteApiPushSubscriptionsPushSubscriptionIdSchema';
import type {
  DeleteOauthAuthorizeMutationResponseSchema,
  DeleteOauthAuthorizeQueryParamsSchema,
  DeleteOauthAuthorize400Schema,
  DeleteOauthAuthorize401Schema,
} from '../types/deleteOauthAuthorizeSchema';
import type {
  GetApiAgreementsLatestEuaQueryResponseSchema,
  GetApiAgreementsLatestEua404Schema,
} from '../types/getApiAgreementsLatestEuaSchema';
import type { GetApiConfigChannelsAppVersionQueryResponseSchema } from '../types/getApiConfigChannelsAppVersionSchema';
import type { GetApiConfigRegionsQueryResponseSchema } from '../types/getApiConfigRegionsSchema';
import type {
  GetApiFeatureFlagsQueryResponseSchema,
  GetApiFeatureFlagsQueryParamsSchema,
  GetApiFeatureFlags422Schema,
} from '../types/getApiFeatureFlagsSchema';
import type {
  GetApiKnowledgeBaseArticlesQueryResponseSchema,
  GetApiKnowledgeBaseArticlesQueryParamsSchema,
  GetApiKnowledgeBaseArticles422Schema,
  GetApiKnowledgeBaseArticles503Schema,
} from '../types/getApiKnowledgeBaseArticlesSchema';
import type {
  GetApiKnowledgeBaseCategoriesQueryResponseSchema,
  GetApiKnowledgeBaseCategories422Schema,
  GetApiKnowledgeBaseCategories503Schema,
} from '../types/getApiKnowledgeBaseCategoriesSchema';
import type {
  GetApiOnboardingQueryResponseSchema,
  GetApiOnboarding401Schema,
  GetApiOnboarding404Schema,
} from '../types/getApiOnboardingSchema';
import type {
  GetApiProductToursProductTourKeyQueryResponseSchema,
  GetApiProductToursProductTourKeyPathParamsSchema,
  GetApiProductToursProductTourKey401Schema,
  GetApiProductToursProductTourKey404Schema,
} from '../types/getApiProductToursProductTourKeySchema';
import type {
  GetApiProjectsProjectIdQueryResponseSchema,
  GetApiProjectsProjectIdPathParamsSchema,
  GetApiProjectsProjectId404Schema,
} from '../types/getApiProjectsProjectIdSchema';
import type { GetApiTimeZonesQueryResponseSchema, GetApiTimeZones401Schema } from '../types/getApiTimeZonesSchema';
import type { GetApiUsersMeQueryResponseSchema, GetApiUsersMe401Schema } from '../types/getApiUsersMeSchema';
import type {
  GetOauthAuthorizeQueryResponseSchema,
  GetOauthAuthorizeQueryParamsSchema,
  GetOauthAuthorize400Schema,
  GetOauthAuthorize401Schema,
} from '../types/getOauthAuthorizeSchema';
import type {
  PatchApiOnboardingMutationRequestSchema,
  PatchApiOnboardingMutationResponseSchema,
  PatchApiOnboarding401Schema,
  PatchApiOnboarding404Schema,
} from '../types/patchApiOnboardingSchema';
import type {
  PatchApiProductToursProductTourKeyMutationRequestSchema,
  PatchApiProductToursProductTourKeyMutationResponseSchema,
  PatchApiProductToursProductTourKeyPathParamsSchema,
  PatchApiProductToursProductTourKey401Schema,
  PatchApiProductToursProductTourKey404Schema,
} from '../types/patchApiProductToursProductTourKeySchema';
import type {
  PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema,
  PatchApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
  PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema,
  PatchApiPushSubscriptionsPushSubscriptionId401Schema,
  PatchApiPushSubscriptionsPushSubscriptionId404Schema,
} from '../types/patchApiPushSubscriptionsPushSubscriptionIdSchema';
import type {
  PatchApiUsersMeMutationRequestSchema,
  PatchApiUsersMeMutationResponseSchema,
  PatchApiUsersMe401Schema,
  PatchApiUsersMe422Schema,
} from '../types/patchApiUsersMeSchema';
import type {
  PatchApiUsersPasswordMutationRequestSchema,
  PatchApiUsersPasswordMutationResponseSchema,
  PatchApiUsersPassword400Schema,
  PatchApiUsersPassword422Schema,
} from '../types/patchApiUsersPasswordSchema';
import type {
  PostApiAgreementsAcceptEuaMutationResponseSchema,
  PostApiAgreementsAcceptEuaQueryParamsSchema,
  PostApiAgreementsAcceptEua400Schema,
  PostApiAgreementsAcceptEua401Schema,
} from '../types/postApiAgreementsAcceptEuaSchema';
import type {
  PostApiAnalyticalEventsMutationRequestSchema,
  PostApiAnalyticalEventsMutationResponseSchema,
  PostApiAnalyticalEventsHeaderParamsSchema,
  PostApiAnalyticalEvents400Schema,
  PostApiAnalyticalEvents401Schema,
} from '../types/postApiAnalyticalEventsSchema';
import type {
  PostApiAuthenticationMutationRequestSchema,
  PostApiAuthenticationMutationResponseSchema,
  PostApiAuthentication400Schema,
} from '../types/postApiAuthenticationSchema';
import type {
  PostApiChannelsDevicesMutationRequestSchema,
  PostApiChannelsDevicesMutationResponseSchema,
  PostApiChannelsDevices400Schema,
  PostApiChannelsDevices401Schema,
  PostApiChannelsDevices422Schema,
} from '../types/postApiChannelsDevicesSchema';
import type {
  PostApiDirectUploadsUserAvatarMutationRequestSchema,
  PostApiDirectUploadsUserAvatarMutationResponseSchema,
  PostApiDirectUploadsUserAvatar400Schema,
  PostApiDirectUploadsUserAvatar401Schema,
} from '../types/postApiDirectUploadsUserAvatarSchema';
import type {
  PostApiFeedbacksMutationRequestSchema,
  PostApiFeedbacksMutationResponseSchema,
  PostApiFeedbacks401Schema,
  PostApiFeedbacks422Schema,
} from '../types/postApiFeedbacksSchema';
import type {
  PostApiLoginRefreshMutationResponseSchema,
  PostApiLoginRefreshHeaderParamsSchema,
  PostApiLoginRefresh400Schema,
  PostApiLoginRefresh401Schema,
} from '../types/postApiLoginRefreshSchema';
import type {
  PostApiLoginMutationRequestSchema,
  PostApiLoginMutationResponseSchema,
  PostApiLogin400Schema,
  PostApiLogin401Schema,
  PostApiLogin422Schema,
} from '../types/postApiLoginSchema';
import type {
  PostApiOnboardingFinishMutationRequestSchema,
  PostApiOnboardingFinishMutationResponseSchema,
  PostApiOnboardingFinish401Schema,
  PostApiOnboardingFinish404Schema,
  PostApiOnboardingFinish422Schema,
} from '../types/postApiOnboardingFinishSchema';
import type {
  PostApiProjectsProjectIdDefaultMutationResponseSchema,
  PostApiProjectsProjectIdDefaultPathParamsSchema,
  PostApiProjectsProjectIdDefault401Schema,
} from '../types/postApiProjectsProjectIdDefaultSchema';
import type {
  PostApiPushSubscriptionsMutationRequestSchema,
  PostApiPushSubscriptionsMutationResponseSchema,
  PostApiPushSubscriptions401Schema,
  PostApiPushSubscriptions422Schema,
} from '../types/postApiPushSubscriptionsSchema';
import type {
  PostApiServiceTokensMutationResponseSchema,
  PostApiServiceTokensHeaderParamsSchema,
  PostApiServiceTokens400Schema,
  PostApiServiceTokens401Schema,
} from '../types/postApiServiceTokensSchema';
import type {
  PostApiUsersConfirmationInstructionsMutationRequestSchema,
  PostApiUsersConfirmationInstructionsMutationResponseSchema,
} from '../types/postApiUsersConfirmationInstructionsSchema';
import type {
  PostApiUsersConfirmationMutationRequestSchema,
  PostApiUsersConfirmationMutationResponseSchema,
  PostApiUsersConfirmation400Schema,
  PostApiUsersConfirmation422Schema,
} from '../types/postApiUsersConfirmationSchema';
import type {
  PostApiUsersPasswordInstructionsMutationRequestSchema,
  PostApiUsersPasswordInstructionsMutationResponseSchema,
} from '../types/postApiUsersPasswordInstructionsSchema';
import type {
  PostApiUsersMutationRequestSchema,
  PostApiUsersMutationResponseSchema,
  PostApiUsers422Schema,
} from '../types/postApiUsersSchema';
import type {
  PostApiUsersUnlockInstructionsMutationRequestSchema,
  PostApiUsersUnlockInstructionsMutationResponseSchema,
} from '../types/postApiUsersUnlockInstructionsSchema';
import type {
  PostOauthAuthorizeMutationRequestSchema,
  PostOauthAuthorizeMutationResponseSchema,
  PostOauthAuthorize400Schema,
  PostOauthAuthorize401Schema,
} from '../types/postOauthAuthorizeSchema';

function getGetApiAgreementsLatestEuaUrl() {
  const res = { method: 'GET', url: `/api/agreements/latest_eua` as const };
  return res;
}

/**
 * @summary Retrieves the latest End User Agreement
 * {@link /api/agreements/latest_eua}
 */
export async function getApiAgreementsLatestEua(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiAgreementsLatestEuaQueryResponseSchema,
    ResponseErrorConfig<GetApiAgreementsLatestEua404Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiAgreementsLatestEuaUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiAgreementsAcceptEuaUrl() {
  const res = { method: 'POST', url: `/api/agreements/accept_eua` as const };
  return res;
}

/**
 * @description After accepting the agreement, the authentication tokens need to be refreshed.
 * @summary Accepts the End User Agreement for the current user
 * {@link /api/agreements/accept_eua}
 */
export async function postApiAgreementsAcceptEua(
  params?: PostApiAgreementsAcceptEuaQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiAgreementsAcceptEuaMutationResponseSchema,
    ResponseErrorConfig<PostApiAgreementsAcceptEua400Schema | PostApiAgreementsAcceptEua401Schema>,
    unknown
  >({
    method: 'POST',
    url: getPostApiAgreementsAcceptEuaUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiAnalyticalEventsUrl() {
  const res = { method: 'POST', url: `/api/analytical/events` as const };
  return res;
}

/**
 * @summary Tracks analytical events
 * {@link /api/analytical/events}
 */
export async function postApiAnalyticalEvents(
  data: PostApiAnalyticalEventsMutationRequestSchema,
  headers?: PostApiAnalyticalEventsHeaderParamsSchema,
  config: Partial<RequestConfig<PostApiAnalyticalEventsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiAnalyticalEventsMutationResponseSchema,
    ResponseErrorConfig<PostApiAnalyticalEvents400Schema | PostApiAnalyticalEvents401Schema>,
    PostApiAnalyticalEventsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiAnalyticalEventsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  });
  return res.data;
}

function getPostApiLoginUrl() {
  const res = { method: 'POST', url: `/api/login` as const };
  return res;
}

/**
 * @summary Authenticates a user
 * {@link /api/login}
 */
export async function postApiLogin(
  data: PostApiLoginMutationRequestSchema,
  config: Partial<RequestConfig<PostApiLoginMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiLoginMutationResponseSchema,
    ResponseErrorConfig<PostApiLogin400Schema | PostApiLogin401Schema | PostApiLogin422Schema>,
    PostApiLoginMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiLoginUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiLogoutUrl() {
  const res = { method: 'DELETE', url: `/api/logout` as const };
  return res;
}

/**
 * @summary Logs out a user
 * {@link /api/logout}
 */
export async function deleteApiLogout(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiLogoutMutationResponseSchema,
    ResponseErrorConfig<DeleteApiLogout401Schema | DeleteApiLogout422Schema>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiLogoutUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiAuthenticationUrl() {
  const res = { method: 'POST', url: `/api/authentication` as const };
  return res;
}

/**
 * @summary Attempts a login with a provider or checks if the account exists
 * {@link /api/authentication}
 */
export async function postApiAuthentication(
  data: PostApiAuthenticationMutationRequestSchema,
  config: Partial<RequestConfig<PostApiAuthenticationMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiAuthenticationMutationResponseSchema,
    ResponseErrorConfig<PostApiAuthentication400Schema>,
    PostApiAuthenticationMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiAuthenticationUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiChannelsDevicesUrl() {
  const res = { method: 'POST', url: `/api/channels/devices` as const };
  return res;
}

/**
 * @summary Adds a device
 * {@link /api/channels/devices}
 */
export async function postApiChannelsDevices(
  data: PostApiChannelsDevicesMutationRequestSchema,
  config: Partial<RequestConfig<PostApiChannelsDevicesMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiChannelsDevicesMutationResponseSchema,
    ResponseErrorConfig<
      PostApiChannelsDevices400Schema | PostApiChannelsDevices401Schema | PostApiChannelsDevices422Schema
    >,
    PostApiChannelsDevicesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiChannelsDevicesUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiChannelsDevicesDeviceIdUrl(
  device_id: DeleteApiChannelsDevicesDeviceIdPathParamsSchema['device_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/channels/devices/${device_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a device
 * {@link /api/channels/devices/:device_id}
 */
export async function deleteApiChannelsDevicesDeviceId(
  device_id: DeleteApiChannelsDevicesDeviceIdPathParamsSchema['device_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiChannelsDevicesDeviceIdMutationResponseSchema,
    ResponseErrorConfig<DeleteApiChannelsDevicesDeviceId401Schema>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiChannelsDevicesDeviceIdUrl(device_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiConfigChannelsAppVersionUrl() {
  const res = {
    method: 'GET',
    url: `/api/config/channels_app_version` as const,
  };
  return res;
}

/**
 * @summary Return the current channels app minimum version
 * {@link /api/config/channels_app_version}
 */
export async function getApiConfigChannelsAppVersion(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetApiConfigChannelsAppVersionQueryResponseSchema, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getGetApiConfigChannelsAppVersionUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiConfigRegionsUrl() {
  const res = { method: 'GET', url: `/api/config/regions` as const };
  return res;
}

/**
 * @summary List all API regions and their URLs
 * {@link /api/config/regions}
 */
export async function getApiConfigRegions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetApiConfigRegionsQueryResponseSchema, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getGetApiConfigRegionsUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiDirectUploadsUserAvatarUrl() {
  const res = {
    method: 'POST',
    url: `/api/direct_uploads/user_avatar` as const,
  };
  return res;
}

/**
 * @summary Creates a direct upload for the user avatar
 * {@link /api/direct_uploads/user_avatar}
 */
export async function postApiDirectUploadsUserAvatar(
  data: PostApiDirectUploadsUserAvatarMutationRequestSchema,
  config: Partial<RequestConfig<PostApiDirectUploadsUserAvatarMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiDirectUploadsUserAvatarMutationResponseSchema,
    ResponseErrorConfig<PostApiDirectUploadsUserAvatar400Schema | PostApiDirectUploadsUserAvatar401Schema>,
    PostApiDirectUploadsUserAvatarMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiDirectUploadsUserAvatarUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiFeatureFlagsUrl() {
  const res = { method: 'GET', url: `/api/feature_flags` as const };
  return res;
}

/**
 * @summary Retrieves the list of feature flags
 * {@link /api/feature_flags}
 */
export async function getApiFeatureFlags(
  params?: GetApiFeatureFlagsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiFeatureFlagsQueryResponseSchema,
    ResponseErrorConfig<GetApiFeatureFlags422Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiFeatureFlagsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiFeedbacksUrl() {
  const res = { method: 'POST', url: `/api/feedbacks` as const };
  return res;
}

/**
 * @summary Creates a feedback
 * {@link /api/feedbacks}
 */
export async function postApiFeedbacks(
  data?: PostApiFeedbacksMutationRequestSchema,
  config: Partial<RequestConfig<PostApiFeedbacksMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiFeedbacksMutationResponseSchema,
    ResponseErrorConfig<PostApiFeedbacks401Schema | PostApiFeedbacks422Schema>,
    PostApiFeedbacksMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiFeedbacksUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiKnowledgeBaseArticlesUrl() {
  const res = { method: 'GET', url: `/api/knowledge_base/articles` as const };
  return res;
}

/**
 * @summary Retrieves knowledge base articles by tag
 * {@link /api/knowledge_base/articles}
 */
export async function getApiKnowledgeBaseArticles(
  params: GetApiKnowledgeBaseArticlesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiKnowledgeBaseArticlesQueryResponseSchema,
    ResponseErrorConfig<GetApiKnowledgeBaseArticles422Schema | GetApiKnowledgeBaseArticles503Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiKnowledgeBaseArticlesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiKnowledgeBaseCategoriesUrl() {
  const res = { method: 'GET', url: `/api/knowledge_base/categories` as const };
  return res;
}

/**
 * @summary Retrieves knowledge base categories
 * {@link /api/knowledge_base/categories}
 */
export async function getApiKnowledgeBaseCategories(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiKnowledgeBaseCategoriesQueryResponseSchema,
    ResponseErrorConfig<GetApiKnowledgeBaseCategories422Schema | GetApiKnowledgeBaseCategories503Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiKnowledgeBaseCategoriesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetOauthAuthorizeUrl() {
  const res = { method: 'GET', url: `/oauth/authorize` as const };
  return res;
}

/**
 * @description Starts the authorization code flow.Returns the pre-authorization payload so the client can render a consent screen (render your approval UI,then POST back). In some conditions, consent can be skipped and the authorization code issued straight away.
 * @summary Validate a forwarded authorization request
 * {@link /oauth/authorize}
 */
export async function getOauthAuthorize(
  params?: GetOauthAuthorizeQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetOauthAuthorizeQueryResponseSchema,
    ResponseErrorConfig<GetOauthAuthorize400Schema | GetOauthAuthorize401Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetOauthAuthorizeUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostOauthAuthorizeUrl() {
  const res = { method: 'POST', url: `/oauth/authorize` as const };
  return res;
}

/**
 * @description Confirms the consent collected from the pre-authorization payload andissues the authorization code, using the parameters the pre-authorizationwas requested with.
 * @summary Grant consent and issue the authorization code
 * {@link /oauth/authorize}
 */
export async function postOauthAuthorize(
  data?: PostOauthAuthorizeMutationRequestSchema,
  config: Partial<RequestConfig<PostOauthAuthorizeMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<PostOauthAuthorize400Schema | PostOauthAuthorize401Schema>,
    PostOauthAuthorizeMutationRequestSchema
  >({
    method: 'POST',
    url: getPostOauthAuthorizeUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteOauthAuthorizeUrl() {
  const res = { method: 'DELETE', url: `/oauth/authorize` as const };
  return res;
}

/**
 * @description Denies the authorization request. No access grant is issued.
 * @summary Deny consent
 * {@link /oauth/authorize}
 */
export async function deleteOauthAuthorize(
  params?: DeleteOauthAuthorizeQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteOauthAuthorizeMutationResponseSchema,
    ResponseErrorConfig<DeleteOauthAuthorize400Schema | DeleteOauthAuthorize401Schema>,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteOauthAuthorizeUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiOnboardingUrl() {
  const res = { method: 'GET', url: `/api/onboarding` as const };
  return res;
}

/**
 * @summary Retrieve the current user onboarding data
 * {@link /api/onboarding}
 */
export async function getApiOnboarding(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiOnboardingQueryResponseSchema,
    ResponseErrorConfig<GetApiOnboarding401Schema | GetApiOnboarding404Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiOnboardingUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiOnboardingUrl() {
  const res = { method: 'PATCH', url: `/api/onboarding` as const };
  return res;
}

/**
 * @summary Updates the current user onboarding
 * {@link /api/onboarding}
 */
export async function patchApiOnboarding(
  data?: PatchApiOnboardingMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiOnboardingMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiOnboardingMutationResponseSchema,
    ResponseErrorConfig<PatchApiOnboarding401Schema | PatchApiOnboarding404Schema>,
    PatchApiOnboardingMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiOnboardingUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiOnboardingFinishUrl() {
  const res = { method: 'POST', url: `/api/onboarding/finish` as const };
  return res;
}

/**
 * @summary Finishes onboarding
 * {@link /api/onboarding/finish}
 */
export async function postApiOnboardingFinish(
  data?: PostApiOnboardingFinishMutationRequestSchema,
  config: Partial<RequestConfig<PostApiOnboardingFinishMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiOnboardingFinishMutationResponseSchema,
    ResponseErrorConfig<
      PostApiOnboardingFinish401Schema | PostApiOnboardingFinish404Schema | PostApiOnboardingFinish422Schema
    >,
    PostApiOnboardingFinishMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiOnboardingFinishUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProductToursProductTourKeyUrl(
  product_tour_key: GetApiProductToursProductTourKeyPathParamsSchema['product_tour_key']
) {
  const res = {
    method: 'GET',
    url: `/api/product_tours/${product_tour_key}` as const,
  };
  return res;
}

/**
 * @summary Retrieves the product tour status for the user
 * {@link /api/product_tours/:product_tour_key}
 */
export async function getApiProductToursProductTourKey(
  product_tour_key: GetApiProductToursProductTourKeyPathParamsSchema['product_tour_key'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProductToursProductTourKeyQueryResponseSchema,
    ResponseErrorConfig<GetApiProductToursProductTourKey401Schema | GetApiProductToursProductTourKey404Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiProductToursProductTourKeyUrl(product_tour_key).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProductToursProductTourKeyUrl(
  product_tour_key: PatchApiProductToursProductTourKeyPathParamsSchema['product_tour_key']
) {
  const res = {
    method: 'PATCH',
    url: `/api/product_tours/${product_tour_key}` as const,
  };
  return res;
}

/**
 * @summary Updates the product tour status for the user
 * {@link /api/product_tours/:product_tour_key}
 */
export async function patchApiProductToursProductTourKey(
  product_tour_key: PatchApiProductToursProductTourKeyPathParamsSchema['product_tour_key'],
  data?: PatchApiProductToursProductTourKeyMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProductToursProductTourKeyMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProductToursProductTourKeyMutationResponseSchema,
    ResponseErrorConfig<PatchApiProductToursProductTourKey401Schema | PatchApiProductToursProductTourKey404Schema>,
    PatchApiProductToursProductTourKeyMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProductToursProductTourKeyUrl(product_tour_key).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdUrl(project_id: GetApiProjectsProjectIdPathParamsSchema['project_id']) {
  const res = { method: 'GET', url: `/api/projects/${project_id}` as const };
  return res;
}

/**
 * @summary Retrieves a project
 * {@link /api/projects/:project_id}
 */
export async function getApiProjectsProjectId(
  project_id: GetApiProjectsProjectIdPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdQueryResponseSchema,
    ResponseErrorConfig<GetApiProjectsProjectId404Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdDefaultUrl(
  project_id: PostApiProjectsProjectIdDefaultPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/default` as const,
  };
  return res;
}

/**
 * @summary Set the default project
 * {@link /api/projects/:project_id/default}
 */
export async function postApiProjectsProjectIdDefault(
  project_id: PostApiProjectsProjectIdDefaultPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdDefaultMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdDefault401Schema>,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdDefaultUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiPushSubscriptionsUrl() {
  const res = { method: 'POST', url: `/api/push_subscriptions` as const };
  return res;
}

/**
 * @summary Creates a push subscription
 * {@link /api/push_subscriptions}
 */
export async function postApiPushSubscriptions(
  data: PostApiPushSubscriptionsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiPushSubscriptionsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiPushSubscriptionsMutationResponseSchema,
    ResponseErrorConfig<PostApiPushSubscriptions401Schema | PostApiPushSubscriptions422Schema>,
    PostApiPushSubscriptionsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiPushSubscriptionsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiPushSubscriptionsPushSubscriptionIdUrl(
  push_subscription_id: PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/push_subscriptions/${push_subscription_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a push subscription
 * {@link /api/push_subscriptions/:push_subscription_id}
 */
export async function patchApiPushSubscriptionsPushSubscriptionId(
  push_subscription_id: PatchApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'],
  data: PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      PatchApiPushSubscriptionsPushSubscriptionId401Schema | PatchApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    PatchApiPushSubscriptionsPushSubscriptionIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiPushSubscriptionsPushSubscriptionIdUrl(push_subscription_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiPushSubscriptionsPushSubscriptionIdUrl(
  push_subscription_id: DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/push_subscriptions/${push_subscription_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a push subscription
 * {@link /api/push_subscriptions/:push_subscription_id}
 */
export async function deleteApiPushSubscriptionsPushSubscriptionId(
  push_subscription_id: DeleteApiPushSubscriptionsPushSubscriptionIdPathParamsSchema['push_subscription_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiPushSubscriptionsPushSubscriptionIdMutationResponseSchema,
    ResponseErrorConfig<
      DeleteApiPushSubscriptionsPushSubscriptionId401Schema | DeleteApiPushSubscriptionsPushSubscriptionId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiPushSubscriptionsPushSubscriptionIdUrl(push_subscription_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiServiceTokensUrl() {
  const res = { method: 'POST', url: `/api/service_tokens` as const };
  return res;
}

/**
 * @summary Creates an access token for a user linked to a service
 * {@link /api/service_tokens}
 */
export async function postApiServiceTokens(
  headers: PostApiServiceTokensHeaderParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiServiceTokensMutationResponseSchema,
    ResponseErrorConfig<PostApiServiceTokens400Schema | PostApiServiceTokens401Schema>,
    unknown
  >({
    method: 'POST',
    url: getPostApiServiceTokensUrl().url.toString(),
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  });
  return res.data;
}

function getPostApiLoginRefreshUrl() {
  const res = { method: 'POST', url: `/api/login/refresh` as const };
  return res;
}

/**
 * @summary Refreshes user authentication
 * {@link /api/login/refresh}
 */
export async function postApiLoginRefresh(
  headers: PostApiLoginRefreshHeaderParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiLoginRefreshMutationResponseSchema,
    ResponseErrorConfig<PostApiLoginRefresh400Schema | PostApiLoginRefresh401Schema>,
    unknown
  >({
    method: 'POST',
    url: getPostApiLoginRefreshUrl().url.toString(),
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  });
  return res.data;
}

function getGetApiTimeZonesUrl() {
  const res = { method: 'GET', url: `/api/time_zones` as const };
  return res;
}

/**
 * @summary Retrieves time zones
 * {@link /api/time_zones}
 */
export async function getApiTimeZones(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetApiTimeZonesQueryResponseSchema, ResponseErrorConfig<GetApiTimeZones401Schema>, unknown>(
    {
      method: 'GET',
      url: getGetApiTimeZonesUrl().url.toString(),
      ...requestConfig,
    }
  );
  return res.data;
}

function getPostApiUsersConfirmationInstructionsUrl() {
  const res = {
    method: 'POST',
    url: `/api/users/confirmation/instructions` as const,
  };
  return res;
}

/**
 * @summary Sends a confirmation email
 * {@link /api/users/confirmation/instructions}
 */
export async function postApiUsersConfirmationInstructions(
  data: PostApiUsersConfirmationInstructionsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiUsersConfirmationInstructionsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiUsersConfirmationInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    PostApiUsersConfirmationInstructionsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiUsersConfirmationInstructionsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiUsersConfirmationUrl() {
  const res = { method: 'POST', url: `/api/users/confirmation` as const };
  return res;
}

/**
 * @summary Confirms a user
 * {@link /api/users/confirmation}
 */
export async function postApiUsersConfirmation(
  data: PostApiUsersConfirmationMutationRequestSchema,
  config: Partial<RequestConfig<PostApiUsersConfirmationMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiUsersConfirmationMutationResponseSchema,
    ResponseErrorConfig<PostApiUsersConfirmation400Schema | PostApiUsersConfirmation422Schema>,
    PostApiUsersConfirmationMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiUsersConfirmationUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiUsersUrl() {
  const res = { method: 'POST', url: `/api/users` as const };
  return res;
}

/**
 * @summary Creates a user
 * {@link /api/users}
 */
export async function postApiUsers(
  data: PostApiUsersMutationRequestSchema,
  config: Partial<RequestConfig<PostApiUsersMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiUsersMutationResponseSchema,
    ResponseErrorConfig<PostApiUsers422Schema>,
    PostApiUsersMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiUsersUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiUsersMeUrl() {
  const res = { method: 'GET', url: `/api/users/me` as const };
  return res;
}

/**
 * @summary Retrieves current user
 * {@link /api/users/me}
 */
export async function getApiUsersMe(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetApiUsersMeQueryResponseSchema, ResponseErrorConfig<GetApiUsersMe401Schema>, unknown>({
    method: 'GET',
    url: getGetApiUsersMeUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiUsersMeUrl() {
  const res = { method: 'PATCH', url: `/api/users/me` as const };
  return res;
}

/**
 * @summary Updates current user
 * {@link /api/users/me}
 */
export async function patchApiUsersMe(
  data: PatchApiUsersMeMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiUsersMeMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiUsersMeMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersMe401Schema | PatchApiUsersMe422Schema>,
    PatchApiUsersMeMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiUsersMeUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiUsersPasswordInstructionsUrl() {
  const res = {
    method: 'POST',
    url: `/api/users/password/instructions` as const,
  };
  return res;
}

/**
 * @summary Sends password reset instructions
 * {@link /api/users/password/instructions}
 */
export async function postApiUsersPasswordInstructions(
  data: PostApiUsersPasswordInstructionsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiUsersPasswordInstructionsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiUsersPasswordInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    PostApiUsersPasswordInstructionsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiUsersPasswordInstructionsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiUsersPasswordUrl() {
  const res = { method: 'PATCH', url: `/api/users/password` as const };
  return res;
}

/**
 * @summary Updates password with reset token
 * {@link /api/users/password}
 */
export async function patchApiUsersPassword(
  data: PatchApiUsersPasswordMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiUsersPasswordMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiUsersPasswordMutationResponseSchema,
    ResponseErrorConfig<PatchApiUsersPassword400Schema | PatchApiUsersPassword422Schema>,
    PatchApiUsersPasswordMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiUsersPasswordUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiUsersUnlockInstructionsUrl() {
  const res = {
    method: 'POST',
    url: `/api/users/unlock/instructions` as const,
  };
  return res;
}

/**
 * @summary Sends an unlock instructions email
 * {@link /api/users/unlock/instructions}
 */
export async function postApiUsersUnlockInstructions(
  data: PostApiUsersUnlockInstructionsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiUsersUnlockInstructionsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiUsersUnlockInstructionsMutationResponseSchema,
    ResponseErrorConfig<Error>,
    PostApiUsersUnlockInstructionsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiUsersUnlockInstructionsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
